import Typography from '@classify/design-tokens/typography';
import { Breakpoints } from '@mui/system';

type TypographyVariants = {
  [key: string]: {
    fontFamily: string;
    fontSize: string;
    letterSpacing: string;
    lineHeight: string;
    fontWeight: string;
    [key: string]: any;
  };
};

const getTypography = ({ breakpoints }: { breakpoints: Breakpoints }) => {
  const typographies: TypographyVariants = {
    ...Typography.content,
    ...Typography.contentImpactMobile,
    ...Typography.form,
    ...Typography.titleMobile,
    ...Typography.action,
    subtitle1: Typography.content.subheading, // deprecated
    subtitle2: Typography.content.subheadingSmall, // deprecated
    body1: Typography.content.body,
    body2: Typography.content.bodySmall,
  };

  // Todo : Should be added in figma
  typographies.button.textTransform = 'Initial';

  const desktopTypography: TypographyVariants = {
    ...Typography.contentImpact,
    ...Typography.title,
  };

  Object.keys(typographies).forEach((variantName: string) => {
    const variant = typographies[variantName];

    if (typeof variant !== 'object' || !desktopTypography[variantName]) {
      return;
    }

    variant[breakpoints.up('sm')] = desktopTypography[variantName];
  });
  return typographies;
};

export default getTypography;
